import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('message-modal-layout', {
  root: {
    states: ['hasIllustration'],
  },
  topAreaContainer: {},
  contentAreaContainer: {},
});
